export const ru = {
    'adaptive-banner': 'Адаптивное объявление',
    'banner-id': '№ {id}',
    duration: '{duration} сек'
};
